import {Dialog, DialogContent, useTheme} from "@mui/material";
import React from "react";
import {MuiRhfStringListField} from "../forms/MuiRhfStringListField";

export function StringListDialog(props: {
  /**
   * The name of the field in the RHF Form in which the string list should be saved
   */
  name: string,
  /**
   * The label to be shown on the input field for new entries
   */
  inputLabel: string,
  /**
   * The title shown on top of the list
   */
  title?: string,
  disabled?: boolean,
  open: boolean,
  handleClose: (event?: {}, reason?: 'backdropClick' | 'escapeKeyDown') => void,
}) {
  const theme = useTheme();

  return (
    <Dialog fullWidth={false} maxWidth={"md"} open={props.open} onClose={props.handleClose} aria-labelledby="form dialog"
            sx={{paper: {maxHeight: '80%',}}}>
      <DialogContent sx={{backgroundColor: theme.palette.background.paper,}}>
        <MuiRhfStringListField name={props.name} inputLabel={props.inputLabel} title={props.title}
                               handleEmptySubmit={props.handleClose} disabled={props.disabled}/>
      </DialogContent>
    </Dialog>
  )
}

